import useToggleHandler from "@/Hooks/useToggleHandler";
import { handleSuccessToast } from "@/UI/Toasts";
import {
  useGetAllSegmentService,
  useUpdateSegmentsMutation,
  useDeleteSegmentsMutation,
} from "@repo/api-services/admin";
import { useState } from "react";
import { THookProps } from "@/types/global.types";
import useRoutesHandler from "@/Hooks/useRouteHandler";
import {
  ISegmentsResponseSchema,
  ISegmentsSubmitSchema,
} from "@repo/api-services/admin-types";
import { handleErrorToast } from "@repo/ui/libs";

const useSegments = ({
  enablePagination = false,
  enablePerPage = false,
}: THookProps) => {
  // States

  const [deleteRecordId, setDeleteRecordId] = useState<number | null>();
  const [isActiveData, setIsActiveData] =
    useState<ISegmentsResponseSchema | null>(null);

  const { isOpen: isViewModalOpen, toggler: viewModalToggler } =
    useToggleHandler();
  const { urlQueries } = useRoutesHandler();
  const updateSegmentMutation = useUpdateSegmentsMutation();

  // URL FIlters
  const pageQuery = enablePagination ? urlQueries.page || "1" : "1";
  const pageSize = enablePerPage ? urlQueries.pagesize || "15" : "15";
  //Query/s
  const {
    services: { getAllSegmentsServices },
    states: { searchQuery, setSearchQuery },
  } = useGetAllSegmentService({ page: pageQuery, per_page: pageSize });

  const deleteSegmentMutation = useDeleteSegmentsMutation();
  const handleDeleteSegmentsMutation = (id: number) => {
    deleteSegmentMutation.mutateAsync(id).then(() => {
      setDeleteRecordId(null);
      getAllSegmentsServices.refetch();
      handleSuccessToast({ message: "Segment deleted Successfully." });
    });
  };

  const isActiveUpdateHandler = (data: ISegmentsSubmitSchema) => {
    if (!data?.id) {
      handleErrorToast({ message: "Can't process the action right now." });
      return;
    }
    updateSegmentMutation
      ?.mutateAsync({
        id: data.id,
        is_enabled: !data?.is_enabled,
      })
      .then(() => {
        setIsActiveData(null);
        getAllSegmentsServices.refetch();
        handleSuccessToast({
          message: `Segment ${
            data?.is_enabled ? "Deactivated" : "Activated"
          } Successfully`,
        });
      });
  };

  return {
    state: {
      deleteRecordId,
      setDeleteRecordId,
      searchQuery,
      setSearchQuery,
      isActiveData,
      setIsActiveData,
      isViewModalOpen,
      viewModalToggler,
    },
    services: { getAllSegmentsServices },
    mutations: { deleteSegmentMutation, updateSegmentMutation },
    functions: {
      handleDeleteSegmentsMutation,
      isActiveUpdateHandler,
    },
  };
};
export default useSegments;
